import React from 'react'
import { Route } from 'react-router'

import { SalesList, SalesEdit } from '.'

export const Sales: React.FC = () => {
  const [dealerId, setDealerId] = React.useState(0)
  const [storeId, setStoreId] = React.useState(0)
  const [keyword, setKeyword] = React.useState('')
  const [currPage, setCurrPage] = React.useState(1)

  const handleDealerChange = (dealerId: number) => {
    setDealerId(dealerId)
    setStoreId(0)
  }

  return (
    <>
      <Route path="/sales" exact render={props => <SalesList
        dealerId={dealerId} dealerOnChange={handleDealerChange}
        storeId={storeId} storeOnChange={setStoreId}
        keyword={keyword} keywordOnChange={setKeyword}
        currPage={currPage} currPageOnChange={setCurrPage}
        {...props} />} />
      <Route path="/sales/:id" component={SalesEdit} />
    </>
  )
}